import { flowRight } from 'lodash';
import ProvisioningPage from '../containers/provisioning-page';
import { withCommunitiesWindowResize } from './with-communities-window-resize';
import { withDirection } from './with-direction';
import { withErrorState } from './with-error-state';
import { withInvalidState } from './with-invalid-state';
import { withLayoutUpdate } from './with-layout-update';
import { withProvisioning } from './with-provisioning';

export function withViewer(AppRoot) {
  return flowRight(
    withDirection,
    withErrorState,
    withProvisioning(ProvisioningPage),
    withInvalidState,
    withLayoutUpdate,
    withCommunitiesWindowResize,
  )(AppRoot);
}
